import "../../App.css"
import { Sidebar, SingleVideoContainer } from "../components"
export const VideoPage = () => {
    return (
        <div className="main-container">
            <Sidebar />
            <SingleVideoContainer />
        </div>
    )
}
